import { Inject, Injectable } from "@angular/core";
import { createEffect, Actions, ofType } from "@ngrx/effects";
import { AuthAction, RESTORE_SESSION, RestoreSessionSuccess, RestoreSessionFail, EXPIRE_SESSION_START, ExpireSessionStart, ExpireSessionEnd, AUTH_LOGOUT, AuthLogout } from "../actions";
import { map, switchMap, take, tap } from "rxjs/operators";
import { Router } from "@angular/router";
import { Subscription, timer } from "rxjs";
import { Store } from "@ngrx/store";
import { AuthState } from "../reducers/auth.reducer";
import { AuthService } from '../../services/auth.service';
import { CLIENT_PORTAL_URL } from "core/tokens/tokens";

@Injectable()
export class AuthEffects {

  expireSub: Subscription;

  constructor(
    private actions$: Actions<AuthAction>,
    private auth2: AuthService,
    private store: Store<AuthState>,
    private router: Router,
    @Inject(CLIENT_PORTAL_URL) private cpUrl: string
  ) { }

  signout$ = createEffect(() => this.actions$.pipe(
    ofType(AUTH_LOGOUT),
    tap(() => {
      const isDiyUser = this.auth2.auth.isDiy;
      this.auth2.signOut();
      this.auth2.redirectUrl = this.router.url;
      console.log('Url: ' + this.auth2.redirectUrl);
      // TODO: This can probably be reduced...
      location.href = `${this.cpUrl}/login`
      // this.router.navigate(['/login']);
    })
  ), { dispatch: false });

  startExpiration$ = createEffect(() => this.actions$.pipe(
    ofType(EXPIRE_SESSION_START),
    switchMap((action: ExpireSessionStart) => {
      return timer(Math.max(1, action.payload - Date.now()))
        // return timer(5000)
        .pipe(take(1))
    }),
    map(() => new AuthLogout())
  ));

  restoreSession$ = createEffect(() => this.actions$.pipe(
    ofType(RESTORE_SESSION),
    map(() => {
      const token = this.auth2.token;
      // console.log('TOKEN: ' + token);

      if (token) {
        // In milliseconds
        const expiration: number = this.auth2.expiration.valueOf();
        this.store.dispatch(new ExpireSessionStart(expiration));
        return new RestoreSessionSuccess({ accessToken: token, expiresAt: expiration });
      } else
        return new RestoreSessionFail();
    })
  ));

}
